import {  Screen, ScreenState } from './models'

export default {
	setWidthHeight(state: ScreenState, screen: Screen): void {
		state.width = screen.width;
		state.height = screen.height
	},
}
	
